import {
  AttendeeFragment,
  PublicEWebinarFragment,
  PublicSetFragment,
  AssetInput,
} from '$/GraphQL/schema/types';

export enum PageMode {
  preview = 'preview',
  edit = 'edit',
  public = 'public',
}

export enum PageName {
  registrationPage = 'registrationPage',
  registrationForm = 'registrationForm',
  thankyouPage = 'thankyouPage',
  regSettings = 'regSettings',
}

export interface PageBuilderState {
  mode: PageMode;
  isFixedNav?: boolean;
  hasNoSession?: boolean;
  set: PublicSetFragment;
  ewebinar: PublicEWebinarFragment;
  attendee?: AttendeeFragment;
  setDefaultSession?: (val: string) => void;
  onButtonClick?: () => void;
}

export type PBState = Omit<PageBuilderState, 'ewebinar' | 'set'>;

export interface LocalAsset extends AssetInput {
  fit?: 'cover' | 'contain';
  position?: 'top center' | 'center center' | 'bottom center';
  hideRecommended?: boolean;
}
